module.exports = __webpack_public_path__ + "img/hero-thumb-9.1a953fce.png";